

const AdminPagination = ({
    pagination,
    onPageChange,
}) => {

    if (!pagination) {
        return null;
    }

    const {
        current_page,
        last_page,
        from,
        to,
        total,
    } = pagination;

    if (last_page <= 1) {
        return (
            <div className="admin-pagination-summary">
                Showing {from || 0}–{to || 0} of {total || 0}
            </div>
        );
    }

    const pages = [];

    const start = Math.max(
        1,
        current_page - 2
    );

    const end = Math.min(
        last_page,
        current_page + 2
    );

    for (
        let page = start;
        page <= end;
        page++
    ) {
        pages.push(page);
    }

    return (
        <div className="admin-pagination">

            <div className="admin-pagination-summary">

                Showing{" "}
                <strong>
                    {from || 0}
                </strong>
                {" – "}
                <strong>
                    {to || 0}
                </strong>
                {" of "}
                <strong>
                    {total || 0}
                </strong>

            </div>


            <div className="admin-pagination-controls">

                <button
                    type="button"
                    disabled={
                        current_page <= 1
                    }
                    onClick={() =>
                        onPageChange(
                            current_page - 1
                        )
                    }
                >
                    ←
                </button>


                {start > 1 && (
                    <>
                        <button
                            type="button"
                            onClick={() =>
                                onPageChange(1)
                            }
                        >
                            1
                        </button>

                        {start > 2 && (
                            <span>
                                ...
                            </span>
                        )}
                    </>
                )}


                {pages.map((page) => (

                    <button
                        key={page}
                        type="button"
                        className={
                            page === current_page
                                ? "active"
                                : ""
                        }
                        onClick={() =>
                            onPageChange(page)
                        }
                    >
                        {page}
                    </button>

                ))}


                {end < last_page && (
                    <>
                        {end <
                            last_page - 1 && (
                            <span>
                                ...
                            </span>
                        )}

                        <button
                            type="button"
                            onClick={() =>
                                onPageChange(
                                    last_page
                                )
                            }
                        >
                            {last_page}
                        </button>
                    </>
                )}


                <button
                    type="button"
                    disabled={
                        current_page >=
                        last_page
                    }
                    onClick={() =>
                        onPageChange(
                            current_page + 1
                        )
                    }
                >
                    →
                </button>

            </div>

        </div>
    );
};

export default AdminPagination;